<template>
    <div id="app">
        <UserCarInfo/>
    </div>
</template>

<script>
    import UserCarInfo from '@/views/UserCarInfo.vue'

    export default {
        name: 'app',
        components: {
            UserCarInfo
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #fff;
    }
</style>
